module.exports = __webpack_public_path__ + "img/canbadge-round-38mm-asa_trimmark.8cc23dcd.png";